import { useEffect, useState } from 'react';

export const useElementHeight = (ref: React.RefObject<HTMLElement>) => {
  const [height, setHeight] = useState<number | null>(null);

  useEffect(() => {
    if (!ref.current) return;

    const element = ref.current;

    // Ustaw wysokość początkową
    setHeight(element.offsetHeight);

    // Obserwator zmian rozmiaru
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === element) {
          setHeight(entry.contentRect.height);
        }
      }
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return height;
};
